import { FC } from 'react';
import { isMobile } from 'react-device-detect';
import { BingoClassicMobile } from './mobile';
import { BingoClassicDesktop } from './desktop';

export const BingoClassic: FC = () => {
    const Component = isMobile ? BingoClassicMobile : BingoClassicDesktop;

    return <Component />;
};
